import React from 'react';
import '../styles/Hero.css';
import BannerImage from './BannerImage';

const Hero = ({ title = 'Your Journey Starts Here' }) => {
  const openUrl = (url) => {
    window.location.href = url;
  };

  const callNow = () => {
    window.location.href = 'tel:+442038393300';
  };

  return (
    <section id="home" className="hero">
      <div className="hero-background">
        <BannerImage />
      </div>
      <div className="hero-overlay"></div>
      <div className="hero-container">
        <h1 className={`hero-title ${title === 'Your Journey Starts Here' ? 'hero-title-home' : ''}`}>{title}</h1>
        <p className="hero-subtitle">24/7 Taxi Service for Airport Transfers, City Rides &amp; Long-Distance Travel.</p>
        <div className="hero-highlights" aria-label="Service highlights">
          <span>Fixed Fares</span>
          <span>Professional Drivers</span>
          <span>24/7 Availability</span>
        </div>
        <div className="hero-cta-group">
          <button type="button" className="hero-cta-button cta-call" onClick={callNow}>Call Now</button>
          <button type="button" className="hero-cta-button cta-book" onClick={() => openUrl('https://booktaxinow.co.uk/')}>Book Now</button>
          <button type="button" className="hero-cta-button cta-quote" onClick={() => openUrl('https://booktaxinow.co.uk/')}>Get Quotation</button>
          <button type="button" className="hero-cta-button cta-airport" onClick={() => openUrl('https://booktaxinow.co.uk/')}>Airport Booking</button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
